import React from 'react';
import { Link } from 'react-router-dom';

const MyProject = ({ myProject }) => {
    const { id, img } = myProject;
    return (
        <div className='transition duration-500 hover:blur-0 hover:filter-none cursor-pointer rounded md:rounded-md overflow-hidden mb-3 sm:mb-6 md:mb-8 lg:mb-0'>
            <div data-aos="zoom-out" data-aos-duration="1500" className='px-0 overflow-hidden hover:blur-none relative group'>
                <div className='h-64 sm:h-96 lg:h-64 2xl:h-96 duration-[.5s] project-card'>
                    <img className='shadow-2xl duration-[2.5s] hover:-translate-y-[calc(100%_-_24rem)] lg:hover:-translate-y-[calc(100%_-_16rem)] 2xl:hover:-translate-y-[calc(100%_-_24rem)] ease-in-out overflow-y-scroll' src={img} alt="" />
                </div>
                <Link to={`/projects/${id}`}>
                    <button className='ml-2 sm:ml-0 font-play h-10 rounded  text-sm  w-36 md:text-green-400 text-white hover:text-white md:bg-[#00283a80] bg-green-600 hover:bg-green-600 transition border-[1px] border-none absolute top-1/2 left-[calc(50%_-_5rem)] md:scale-150 md:opacity-0 group-hover:block group-hover:scale-100 group-hover:opacity-100 duration-500 ease-in-out'>
                        See Features
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default MyProject;